var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#color_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M14.751 10.587c-.27-.32-.672-.316-.938.006-.511.62-1.257 1.676-1.257 2.498 0 1.286.818 2.108 1.722 2.152.78.038 1.722-.767 1.722-2.152 0-.866-.738-1.9-1.249-2.504m-9.438 4.656a1.7 1.7 0 0 0 1.218.505c.46 0 .891-.18 1.217-.505l5.417-5.417a.86.86 0 0 0 0-1.217L6.531 1.974 5.165.609a.86.86 0 1 0-1.217 1.217l.658.658a1 1 0 0 1 0 1.414L.504 8A1.7 1.7 0 0 0 0 9.217c0 .46.18.892.504 1.217zm.51-10.127a1 1 0 0 1 1.415 0L9.632 7.51c.63.63.184 1.707-.707 1.707h-4.79c-.89 0-1.336-1.077-.706-1.707z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "color_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgColor;